import { useAuth } from "@clerk/clerk-react";
import { WORKING_COPY_FEATURE } from "./billing.js";
import { cn } from "./cn.js";

export function useWorkingCopyPlan(): { loaded: boolean; pro: boolean } {
	const { has, isLoaded } = useAuth();
	return {
		loaded: isLoaded,
		pro: Boolean(isLoaded && has?.({ feature: WORKING_COPY_FEATURE })),
	};
}

type Props = {
	className?: string;
	/** When set, the badge is a button that opens billing. */
	onOpen?: () => void;
};

/**
 * Clerk org entitlement — Pro when the workspace has `working_copy`.
 * Free until checkout. Same source as capture and Settings → Billing.
 */
export function PlanBadge({ className, onOpen }: Props) {
	const { loaded, pro } = useWorkingCopyPlan();
	if (!loaded) return null;
	const label = pro ? "Pro" : "Free";
	const classes = cn("plan-badge", pro && "plan-badge--pro", className);
	if (onOpen) {
		return (
			<button
				type="button"
				className={classes}
				onClick={onOpen}
				aria-label={pro ? "Pro plan" : "Free plan — open billing"}
			>
				{label}
			</button>
		);
	}
	return <span className={classes}>{label}</span>;
}
